import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { TrendUp } from "@phosphor-icons/react";
import BeforeAfterSlider from "./BeforeAfterSlider";

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/transformations").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="transformations" className="py-24 px-6 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <p className="font-heading uppercase tracking-[0.2em] text-xs text-[#D4AF37] mb-2">Real Bay Area Results</p>
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl text-white tracking-tight mb-2">Transformations, Not Talk</h2>
        <p className="text-sm text-[#71717A] mb-12">Drag the slider on each photo to see the before &amp; after.</p>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <div key={t.id} data-testid={`transformation-card-${i}`} className="relative rounded-2xl overflow-hidden group h-[420px]">
              {t.before_image ? (
                <BeforeAfterSlider
                  beforeImage={t.before_image}
                  afterImage={t.image}
                  alt={t.client_name}
                  testId={`before-after-slider-${i}`}
                  className="absolute inset-0 w-full h-full"
                />
              ) : (
                <img src={t.image} alt={t.client_name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/10 to-transparent pointer-events-none" />
              <div className="absolute bottom-0 left-0 p-5 pointer-events-none">
                <p className="flex items-center gap-1.5 text-[#D4AF37] text-xs font-semibold uppercase tracking-wide mb-1">
                  <TrendUp size={14} weight="bold" /> {t.result}
                </p>
                <p className="font-heading text-xl text-white tracking-tight">{t.client_name}</p>
                <p className="text-sm text-[#D4D4D8]">{t.story}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
